var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 15H27C27.2652 15 27.5196 15.1054 27.7071 15.2929C27.8946 15.4804 28 15.7348 28 16C28 16.2652 27.8946 16.5196 27.7071 16.7071C27.5196 16.8946 27.2652 17 27 17H7C6.73478 17 6.48043 16.8946 6.29289 16.7071C6.10536 16.5196 6 16.2652 6 16C6 15.7348 6.10536 15.4804 6.29289 15.2929C6.48043 15.1054 6.73478 15 7 15Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41383 16.0003L15.7078 24.2923C15.8956 24.4801 16.0011 24.7347 16.0011 25.0003C16.0011 25.2658 15.8956 25.5205 15.7078 25.7083C15.5201 25.8961 15.2654 26.0015 14.9998 26.0015C14.7343 26.0015 14.4796 25.8961 14.2918 25.7083L5.29183 16.7083C5.19871 16.6154 5.12482 16.505 5.07441 16.3836C5.024 16.2621 4.99805 16.1318 4.99805 16.0003C4.99805 15.8688 5.024 15.7385 5.07441 15.617C5.12482 15.4955 5.19871 15.3852 5.29183 15.2923L14.2918 6.29229C14.4796 6.10451 14.7343 5.99902 14.9998 5.99902C15.2654 5.99902 15.5201 6.10451 15.7078 6.29229C15.8956 6.48006 16.0011 6.73474 16.0011 7.00029C16.0011 7.26584 15.8956 7.52051 15.7078 7.70829L7.41383 16.0003Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftBlackIcon);
export default __webpack_public_path__ + "static/media/left-black-icon.e85c2170ef0b8d7272aca0a5e3b953dd.svg";
export { ForwardRef as ReactComponent };